import axios from 'axios';
import { get } from 'lodash';

import errorHandler from './errorHandler';
import { loading, loaded } from './spinner';

const axiosConfig = {
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'Cache-Control': 'no-cache',
    Pragam: 'no-cache',
    Expires: 0,
  },
  timeout: 60000,
  withCredentials: true,
  crossOrigin: true,
  ignore: false,
};

const XY = {
  x: 0,
  y: 0,
};

const _XY = {
  x: 0,
  y: 0,
};

let isMouseClick = false;
let isKeyPress = false;

document.addEventListener('mousemove', function (e) {
  XY['x'] = e.clientX;
  XY['y'] = e.clientY;
});

document.addEventListener('click', function (e) {
  isMouseClick = true;
});

window.addEventListener('keypress', function (e) {
  if (e.keyCode == 13 || e.keyCode == 32) {
    isKeyPress = true;
  }
});

const random1 = () => {
  const numbers = [1, 7, 8];
  const index = Math.floor(Math.random() * numbers.length);
  return numbers[index];
};
const random2 = () => {
  const numbers = [2, 5, 6];
  const index = Math.floor(Math.random() * numbers.length);
  return numbers[index];
};

const getTimeStamp = (url) => {
  const timestamp = new Date().getTime();
  if (url.indexOf('polyv/token') !== -1) {
    const ts = `${timestamp}`.substr(0, `${timestamp}`.length - 1);
    if (XY['x'] != _XY['x'] || XY['y'] != _XY['y']) {
      _XY['x'] = XY['x'];
      _XY['y'] = XY['y'];
      return `${ts}${random1()}`;
    } else if (isMouseClick) {
      isMouseClick = false;
      return `${ts}${random1()}`;
    } else if (isKeyPress) {
      isKeyPress = false;
      return `${ts}${random1()}`;
    } else {
      return `${ts}${random2()}`;
    }
  } else {
    return `${timestamp}`;
  }
};

const axiosClient = axios.create(axiosConfig);

axiosClient.interceptors.request.use(
  (payload) => {
    if (payload && payload.url && payload.url.indexOf('/api') !== -1) {
      let i = '';
      i = payload.url.indexOf('?') === -1 ? '?' : '&';
      payload.url = payload.url + i + 'timestamp=' + getTimeStamp(payload.url);
    }

    if (!payload.ignoreLoading) {
      loading(payload.ignore);
    }
    return payload;
  },
  (error) => {
    loaded();
    // eslint-disable-next-line compat/compat
    return Promise.reject(error);
  }
);

axiosClient.interceptors.response.use(
  (response) => {
    loaded();
    return response;
  },
  (error) => {
    const httpCode = get(error, 'response.status', null);
    const serverCode = get(error, 'response.data.status', null);
    if (httpCode) {
      errorHandler(httpCode);
    } else if (serverCode) {
      errorHandler(serverCode);
    }
    loaded();
    // eslint-disable-next-line compat/compat
    return Promise.reject(error);
  }
);

export default axiosClient;
